import Box from "@mui/material/Box";

const MagnetOffIcon = ({ size = 16 }) => (
  <Box
    component="svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    sx={{
      display: "block",
      "& path": {
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      },
    }}
  >
    <path d="m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15" />
    <path d="m5 8 4 4" />
    <path d="m12 15 4 4" />
    <path d="M2 2 L22 22" />
  </Box>
);

export default MagnetOffIcon;
